import React,{useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';

const {FiCheck,FiSend}=FiIcons;

export default function PostbackConfigPanel({
  templateUrl,
  setTemplateUrl,
  isSaving,
  onSave
}) {
  const [transactionId,setTransactionId]=useState('TEST_TRANSACTION_001');
  const [amount,setAmount]=useState('99.99');
  const [isSending,setIsSending]=useState(false);
  const [result,setResult]=useState(null);

  const sendTestPostback=async ()=> {
    if (!templateUrl.trim()) {
      setResult({error: 'Enter an Active URL Template before sending a test.'});
      return;
    }

    setIsSending(true);
    setResult(null);

    const {data,error}=await supabase.functions.invoke('leguprx-webhook',{
      body: {
        manual_postback: true,
        postback_url_template: templateUrl,
        transaction_id: transactionId.trim() || 'TEST_TRANSACTION_001',
        amount: amount.trim() || '0'
      }
    });

    if (error) {
      setResult({error: error.message});
    } else if (!data?.success) {
      setResult({error: data?.error || 'The postback could not be sent.'});
    } else {
      setResult({success: `Sent successfully. HTTP status: ${data.status}`});
    }

    setIsSending(false);
  };

  return (
    <div className="max-w-3xl">
      <h2 className="text-xl font-bold text-slate-800 mb-4">
        Dynamic Postback Configuration
      </h2>
      <p className="text-slate-600 mb-6 text-sm leading-relaxed">
        Set the URL template that will be fired when a conversion occurs.
        Available placeholders:
        <br />
        {['{TRANSACTION_ID}','{AMOUNT}','{ORDER_ID}','{SLOT}'].map((item)=> (
          <code
            key={item}
            className="bg-slate-100 px-1.5 py-0.5 rounded text-teal-700 border border-slate-200 font-mono mt-2 inline-block mr-2"
          >
            {item}
          </code>
        ))}
      </p>

      <div className="mb-6">
        <label className="block text-sm font-bold text-slate-700 mb-2">
          Active URL Template
        </label>
        <textarea
          className="w-full p-4 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 outline-none font-mono text-sm shadow-inner bg-slate-50"
          rows="4"
          value={templateUrl}
          onChange={(event)=> setTemplateUrl(event.target.value)}
        />
      </div>

      <div className="flex flex-wrap gap-4 mb-10">
        <button
          onClick={()=> onSave(templateUrl)}
          disabled={isSaving}
          className="bg-teal-600 text-white px-6 py-2.5 rounded-lg hover:bg-teal-700 transition flex items-center gap-2 font-medium disabled:opacity-60"
        >
          <SafeIcon icon={FiCheck} />
          {isSaving ? 'Saving...' : 'Save URL Template'}
        </button>
        <button
          onClick={()=> setTemplateUrl(
            'https://glitchy.go2cloud.org/aff_lsr?transaction_id={TRANSACTION_ID}&amount={AMOUNT}&security_token=11636d9414e4e043bc16aee8dc9cacd7'
          )}
          className="bg-white border border-slate-300 text-slate-700 px-6 py-2.5 rounded-lg hover:bg-slate-50 transition font-medium"
        >
          Preset: Glitchy Production URL
        </button>
        <button
          onClick={()=> setTemplateUrl(
            'https://httpbun.com/get?transaction_id={TRANSACTION_ID}&amount={AMOUNT}'
          )}
          className="bg-white border border-slate-300 text-slate-700 px-6 py-2.5 rounded-lg hover:bg-slate-50 transition font-medium"
        >
          Preset: HttpBun Test URL
        </button>
      </div>

      <div className="border-t border-slate-200 pt-8">
        <h3 className="text-lg font-bold text-slate-800 mb-2">
          Manual Postback Test
        </h3>
        <p className="text-sm text-slate-500 mb-5">
          Sends only the values included in the Active URL Template. The test
          request does not generate or append an order ID, slot, or other fields.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Transaction ID
            </label>
            <input
              value={transactionId}
              onChange={(event)=> setTransactionId(event.target.value)}
              className="w-full px-4 py-3 border border-slate-300 rounded-lg outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Price / Amount
            </label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={amount}
              onChange={(event)=> setAmount(event.target.value)}
              className="w-full px-4 py-3 border border-slate-300 rounded-lg outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>
        </div>

        <button
          onClick={sendTestPostback}
          disabled={isSending}
          className="bg-slate-900 text-white px-6 py-3 rounded-lg hover:bg-slate-700 transition flex items-center gap-2 font-medium disabled:opacity-60"
        >
          <SafeIcon icon={FiSend} />
          {isSending ? 'Sending Payload...' : 'Send Test Payload'}
        </button>

        {result?.success && (
          <p className="mt-4 text-sm font-medium text-green-700">
            {result.success}
          </p>
        )}
        {result?.error && (
          <p className="mt-4 text-sm font-medium text-red-600">
            {result.error}
          </p>
        )}
      </div>
    </div>
  );
}